import ChartDataItem from '@/models/ChartDataItem';

export default class ChartData {
  public items: ChartDataItem[];

  constructor(items: ChartDataItem[]) {
    this.items = items;
  }
}
